import { ArrowLeft } from 'lucide-react';
import MGButton from "../../../components/MGButton/MGButton";
import "./PaymentConfirmation.css"

export default function PaymentConfirmation({ clickBack, clickContinue }) {
    return (
        <div className="TermsConditionsContainer">
            <div className="TermsConditionsHeader">
                <div className="QuotasHeader">
                    <ArrowLeft onClick={clickBack} />
                    <span>Confirmação de dados</span>
                </div>
                <span className="QuotasHeader__description">Confirme os dados de pagamento para finalizar a operação.</span>
            </div>
            <div className="TermsConditionsBody">
                <div className='PaymentConfirmationBaseCard'>
                    <span className='PaymentConfirmationBaseLabel'>Método de pagamento</span>
                    <span className='PaymentConfirmationBaseValue'>Débito Direto</span>
                    <span className='PaymentConfirmationBaseLabel'>Total de quotas a pagar</span>
                    <span className='PaymentConfirmationBaseValue'>52,00 €</span>
                </div>
            </div>
            <div className="TermsConditionsFooter">
                <div>
                    <MGButton label="Continuar" type="primary" isEnable={true} onClick={() => clickContinue()} />
                </div>
            </div>
        </div>
    );
}